import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { TabsService } from '../../services/tabs.service';

@Component({
  selector: 'tab-content',
  templateUrl: './tab-content.component.html',
  styleUrls: ['./tab-content.component.scss']
})
export class TabContentComponent implements OnInit {
  @ViewChild('tabContent', { read: ViewContainerRef, static: true })
  target: ViewContainerRef;

  constructor(private tabsService: TabsService) {}

  ngOnInit() {
    this.tabsService.initializeTabsContent(this.target);
  }
}
